import { render } from "./newrelic.vue?vue&type=template&id=c2ff3686"
import script from "./newrelic.vue?vue&type=script&lang=js"
export * from "./newrelic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__